import { render, staticRenderFns } from "./PwaStatusNotices.vue?vue&type=template&id=344555df&scoped=true&"
import script from "./PwaStatusNotices.vue?vue&type=script&lang=js&"
export * from "./PwaStatusNotices.vue?vue&type=script&lang=js&"
import style0 from "./PwaStatusNotices.vue?vue&type=style&index=0&id=344555df&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344555df",
  null
  
)

export default component.exports